import React from 'react';
import PropTypes from 'prop-types';
import styled, { ThemeProvider } from 'styled-components';
import { useMediaQuery } from 'react-responsive';
import Header from './series-lead-elements/header';
import WhatIsInside from './series-lead-elements/what-is-inside';
import Companies from './series-lead-elements/companies';
import Form from './series-lead-elements/form';
import Footer from './series-lead-elements/footer';
import theme from '../../../assets/stylesheets/_settings.global.scss';

const Div = styled.div`
  display: flex;
  flex-direction: column;
`;

export default function Root(props) {
  const isPortrait = useMediaQuery({ query: '(orientation: portrait)' });
  const themeState = {
    ...props,
    ...theme,
    isPortrait,
  };

  const header = {
    title: 'The one thing investors can’t ignore in 2020',
    buttonText: 'download my 2020 ebook',
    desc: 'We reached out to 45 of Australia’s top fund managers and analysts '
      + 'and asked them to pick one idea for the year ahead and distill it '
      + 'into just a few paragraphs. From equities to fixed income, Macro to '
      + 'alternatives, Livewire’s 2020 eBook delivers some eye-opening insights '
      + 'across a variety of asset classes to help investors navigate the year '
      + 'ahead.',
  };

  const inside = {
    title: 'Learn from Australia’s best fund managers',
    desc: '2019 saw a year of unpredictability. From trade wars, to failed '
      + 'IPOs, to the boom of tech stocks – it was never easy to see what was '
      + 'around the corner. So, will 2020 deliver the same unpredictability? '
      + 'Livewire has teamed up with our contributors to deliver expert '
      + 'insights on the year to come, across a variety of asset classes '
      + 'including:',
    bullets: [
      'Australian equities',
      'Income',
      'Real estate',
      'Global equities',
      'Fixed Income',
      'Alternatives',
      'Infrastructure',
      'Disruption',
      'Macro',
      'Multi-Asset',
    ],
  };

  return (
    <ThemeProvider theme={themeState}>
      <Div>
        <Header header={header} />
        <WhatIsInside inside={inside} />
        <Companies ebookName={header.title} />
        <Form ebookName="2020 series" />
        <Footer />
      </Div>
    </ThemeProvider>
  );
}

/* eslint-disable react/no-unused-prop-types */
Root.propTypes = {
  logo: PropTypes.string.isRequired,
  cover: PropTypes.string.isRequired,
  ebook: PropTypes.arrayOf(PropTypes.string).isRequired,
  partners: PropTypes.arrayOf(PropTypes.string).isRequired,
};
/* eslint-enable react/no-unused-prop-types */
